import '@/styles/globals.scss'
import 'moment/locale/ja'

import { AppState, Auth0Provider } from '@auth0/auth0-react'
import { config } from '@fortawesome/fontawesome-svg-core'
import moment from 'moment-timezone'
import { AppProps } from 'next/app'
import Router from 'next/router'
import React, { FC } from 'react'
import { DndProvider } from 'react-dnd'
import { TouchBackend } from 'react-dnd-touch-backend'
import styled from 'styled-components'

import { ContainerAuthenticated } from '@/components/containers/authenticated'
import { ContainerSplash } from '@/components/containers/splash'
import {
  DeviceProvider,
  HtmlMetaProvider,
  NotificationProvider,
  ServiceContext,
  ServiceProvider,
  ThemeProvider
} from '@/contexts'

// Import the CSS
config.autoAddCss = false

// initilized moment
moment.tz.setDefault('Asia/Tokyo')
moment.locale('ja')

const Window = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  display: flex;
  flex-direction: column;
`

const onRedirectCallback = (appState?: AppState) => {
  Router.replace(appState?.returnTo || '/')
}

const App: FC<AppProps> = (props) => {
  return (
    <Window>
      <HtmlMetaProvider>
        <DeviceProvider>
          <ThemeProvider>
            <NotificationProvider>
              <DndProvider backend={TouchBackend} options={{ enableMouseEvents: true }}>
                <Auth0Provider
                  screen_hint={props.router.asPath === '/?screen_hint=signup' ? 'signup' : null}
                  domain={process.env.NEXT_PUBLIC_AUTH0_DOMAIN}
                  clientId={process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID}
                  redirectUri={typeof window !== 'undefined' && window.location.origin}
                  audience={`https://${process.env.NEXT_PUBLIC_AUTH0_DOMAIN}/api/v2/`}
                  scope={process.env.NEXT_PUBLIC_AUTH0_SCOPE}
                  onRedirectCallback={onRedirectCallback}>
                  <ServiceProvider>
                    <ServiceContext.Consumer>
                      {(content) =>
                        content.current ? (
                          <ContainerAuthenticated {...props} />
                        ) : (
                          <ContainerSplash {...content} />
                        )
                      }
                    </ServiceContext.Consumer>
                  </ServiceProvider>
                </Auth0Provider>
              </DndProvider>
            </NotificationProvider>
          </ThemeProvider>
        </DeviceProvider>
      </HtmlMetaProvider>
    </Window>
  )
}

export default App
